import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";

function Form() {

    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const path = '/announcementcategories/';
    const paths = {
        endpointSave: config.endpoints.backend + 'announcementcategories/save',
        endpointGetById: config.endpoints.backend + 'announcementcategories/getById',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Categoria de Comunicado",
        labelTitleEdit: "Editar Categoria de Comunicado",
        labelTitleView: 'Visualizar Categoria de Comunicado'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            fields: [
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }
            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
